var style = {color: "var(--main)", marginLeft: "10px"};
export const MemoViewData = [
    {
        value: 2,
        title : 'Global',
        icon: "fas fa-globe"// global
    },
    {
        value: 1,
        title : 'Admins',
        icon: "fas fa-users-cog"// admins
    },
    {
        value: 0,
        title : 'Perso',
        icon: "fas fa-low-vision"// perso
    },
]

const getIconDataByView = (indexView)=>{
    return MemoViewData.find(icon => icon.value === indexView)
}
export const getValueByTitle = (title)=>{
    return MemoViewData.find(row => row.title === title)?.value
}


export const getIconByView= (indexView) =>{
    return getIconDataByView(indexView)?.icon
}
export const getTitleByView= (indexView) =>{
    return getIconDataByView(indexView)?.title
}
export const MemoViewTypes = [
    {
        value: getTitleByView(2),
        text: <span>Global <i class={getIconByView(2)}style={style}></i> </span> // global
    },
    {
        value: getTitleByView(1),
        text: <span>Admins <i class={getIconByView(1)}style={style}></i> </span> // admins
    },
    {
        value:getTitleByView(0),
        text: <span>Perso <i class={getIconByView(0)}style={style}></i> </span> // perso
    },
]

